import enLocale from "element-ui/lib/locale/lang/en"; // 引入element语言包
import privacyEN from "./privacyEN.js"; //中文隐私政策

const en = {
  error: {
    msg: "Error occurred - Code 404",
    worry: "Don't worry, you can try refreshing a few times",
    refresh: "Refresh page",
    back: "Return to homepage",
  },
  loadingText: "Loading...",
  publicText: {
    sure: "determine",
    cancel: "cancel",
    submit: "Submit",
    title: "Tips",
    edition: "Version information",
    txt: "FSOM Guoke",
    model: "Product model",
    noData: "No such product",
  },
  message: {
    whether: "Whether the payment is successful",
    zfsuccess: "Payment successful",
    zfdestruction: "Payment failure",
  },
  //顶部欢迎条
  headerTop: {
    wel: "Hello, welcome to FSOM shopping center!",
    login: "Login and registration",
    msg: "Message center",
    board: "Message Board",
  },
  //带搜索的top
  header: {
    all: "All",
    key: "Enter keywords",
    sopC: "Shopping Cart",
    goods: "goods",
    user: "user",
    tel: "Hotline",
    Mycart: "My shopping cart",
    place: "place order",
    complete: "Complete order",
    returns: "return",
  },
  // 公共tab切换
  tab: {
    footPrint: ["MyTracks"],
    Collection: ["Mycollection"],
    project: ["Myproject"],
    longrange: ["Remote technical support"],
  },
  // 关于我们
  aboutUS: {
    briefintroduction: "Company profile",
    idea: "philosophy",
    Mainbusiness: "Main business",
    purpose: "Our purpose",
    cp: "Company Profile",
    newForm: "News Information",
    customer: "Customer Service Center",
  },
  // 提示
  Tips: {
    perfect: "Please complete the information",
    applysuc: "Successful application",
    num: "Quantity must be an integer",
    collectionsuc: "Collection successful",
    addsuc: "Successfully added",
    sccancel: "Confirm to cancel collection？",
    Tips: "Tips",
    zjDel: "Do you want to delete this footstep?",
    delsuc: "Delete succeeded",
    qxDel: "Cancel deletion",
    projectTips: "Are you sure to cancel the project？",
    qxsuc: "Cancellation succeeded",
    SubmitTips: "Are you sure you want to submit this project?",
    Submitsue: "Submitted successfully",
    telWrong: "Your mobile number is wrong",
    xmeditsuc: "Project edited successfully",
    Receiptsuc: "Successful receipt",
    Billingsuc: "Invoicing succeeded",
    Aftersalestype: "Please select after sales type",
    Aftersalesdescription: "Please enter after sales description",
    uploadsuc: "Upload succeeded",
    upTips: "You can only select at most one file",
    fillin: "Please fill in",
    out: "Log out or not?",
    outsuc: "Exit successful",
    qxordersuc: "Are you sure to cancel the order？",
    confirm: "confirm",
    cancel: "cancel",
    modifysuc: "Modification succeeded",
    mailbox: "Please enter email",
    code: "Verification code sent",
    txTips: "Whether to confirm withdrawal？",
    txsuc: "Withdrawal successful",
    txfail: "Withdrawal failure",
    setupsuc: "Set successfully",
    paymentsuc: "Payment successful",
    RMBaccount: "Insufficient balance of RMB account",
    USDaccount: "Insufficient balance in USD account",
    Tick: "Please check FSOM privacy terms",
    registersuc: "login was successful",
    search: "Search content cannot be empty",
    shop: "Please select at least one item",
    dataTips: "Are you sure to submit the data?",
    nojurisdiction: "No download permission",
  },
  // 修改个人资料
  modifyUser: {
    upload: "Upload Avatar",
    fullname: "full name",
    China: "China",
    tel: "Telephone",
    modify: "modify",
    Gender: "Gender",
    male: "male",
    female: "female",
    region: "region",
    company: "company",
    preservation: "preservation",
  },
  // 修改密码
  modifyPsd: {
    Tips: "Warm tip: please make the password as complex as possible, 8-20 digits, alphanumeric combination",
    Original: "Original password",
    new: "New password",
    confirm: "Confirm new password",
    modify: "Confirm modification",
    rules: {
      pPassword: [
        {
          required: true,
          message: "Please enter the original password",
          trigger: "blur",
        },
      ],
      nPassword: [
        {
          required: true,
          message: "Please enter a new password",
          trigger: "blur",
        },
        {
          min: 8,
          max: 20,
          message: "8 to 20 characters in length",
          trigger: "blur",
        },
      ],
      sPassword: [
        {
          required: true,
          message: "Please confirm the new password",
          trigger: "blur",
        },
      ],
      msgTips:
        "The confirmation password is inconsistent with the new password",
      modifysuc: "Modification succeeded",
    },
  },
  // 支付
  payment: {
    ordernumber: "order number",
    Tips: "Please pay as soon as possible",
    Totalamount: "Total amount",
    Alipay: "Alipay",
    use: "Payment is made with Alipay",
    recommend: "recommend",
    payment: "payment",
    txt: "International payment instrument, 50 thousand yuan per day",
    RMB: "RMB account",
    balance: "Balance payment",
    dollar: "USD account",
    Paynow: "Pay now",
    setpassword: "Set payment password",
    mailbox: "mailbox",
    inpmailbox: "Please enter email address",
    zqmailbox: "Please enter the correct email address",
    obtain: "Get verification code",
    send: "Seconds to send",
    code: "Verification Code",
    input: "Please enter",
    Paymentpassword: "password",
    setup: "Set now",
    inppassword: "Enter payment password",
    determine: "determine",
  },
  // 充值&提现
  Recharge: {
    title: "Please make sure the withdrawal account is correct",
    Totalamount: "Total amount",
    Recharge: "Recharge",
    Withdrawal: "Withdrawal",
    money: "amount of money",
    moneyinput: "Please enter the amount, up to 50000 at a time",
    account: "account number",
    accountinput: "Please enter withdrawal account number",
    Alipay: "Alipay",
    txt: "Payment is made with Alipay",
    recommend: "recommend",
    payment: "payment",
    international: "International payment instrument",
    Paynow: "Pay now",
    withdrawal: "withdrawal",
  },
  // 收货信息
  Receipt: {
    information: "New consignee information",
    name: "Organization name",
    consignee: "consignee",
    country: "country",
    address: "Detailed address",
    Zipcode: "Zip code",
    tel: "contact number",
    occupation: "Your career",
    choice: "Please select",
    operation: "operation",
    modify: "modify",
    delete: "delete",
    default: "Default address",
    setup: "Set as default",
    newlyadded: "New address",
    my: "My shipping address",
    close: "close",
    new: "newly added",
    edit: "edit",
    input: "Please enter content",
    Submit: "Submit",
    dataTitleGroup: {
      mechanismName: "Organization name",
      contacts: "consignee",
      country: "Country / Region",
      address: "Receiving address",
      zipCode: "Zip code",
      contactPhone: "contact number",
    },
  },
  // 购物车
  Shopping: {
    Allproducts: "All products",
    Total: "Total (excluding freight)",
    spinformation: "Commodity information",
    UnitPrice: "Unit Price",
    number: "number",
    money: "amount of money",
    operation: "operation",
    delete: "delete",
    Selectall: "Select all",
    Selected: "Selected items",
    settlement: "settlement",
  },
  //下单页面
  placeorder: {
    Shopping: "Shopping Cart",
    userinformation: "Fill in and check the consignee information",
    shinformation: "Receiving information",
    shaddress: "Add receiving address",
    mraddress: "Default address",
    edit: "edit",
    ddinformation: "Confirm order information",
    Nodata: "No data available",
    number: "number",
    describe: "describe",
    use: "use",
    element: "element",
    Creditdeduction: "credits to deduct",
    Modeofdelivery:
      "Delivery method: ordinary delivery, express delivery and free of post",
    Memberdiscount: "Use member discount",
    fracture: "fracture",
    Totalgoods: "Total goods (including freight)",
    Actualpayment: "Actual payment",
    To: "To",
    consignee: "consignee",
    Ordernow: "Order now",
    newlyadded: "newly added",
    Receivingaddress: "Receiving address",
    close: "close",
    Pleaseenter: "Please enter content",
    Submit: "Submit",
    thead: [
      {
        title: "Commodity information",
        width: "col-9",
        align: "center",
      },
      {
        title: "Unit Price",
        width: "col-4 weight-font",
        align: "center",
      },
      {
        title: "number",
        width: "col-3 weight-font",
        align: "center",
      },
      {
        title: "amount of money",
        width: "col-4 weight-font",
        align: "center",
      },
    ],
  },
  // 注册
  register: {
    modify: "Modify now",
    forget: "Forget password",
    Memberregistration: "Member registration",
    Existingaccount: "Existing account",
    Signinnow: "Sign in now",
    name: "name",
    Pleaseenteraname: "Please enter a name",
    surname: "surname",
    Pleaseenterlastname: "Please enter last name",
    Telephone: "Telephone",
    PleaseenterTel: "Please enter the phone number",
    mailbox: "mail box",
    SendCode: "Send verification code",
    sendout: "Seconds to send",
    Pleaseentermailbox: "Please enter email",
    mailboxCode: "Email verification code",
    PleaseentermailboxCode: "Please enter email verification code",
    password: "password",
    Pleaseenterpassword: "Please input a password",
    Reconfirm: "Reconfirm",
    Pleasereconfirm: "Please reconfirm",
    country: "country",
    Pleaseentercountry: "Please enter country",
    province: "Provinces and cities",
    Pleaseenterprovince: "Please enter country",
    company: "Company / learning",
    Pleaseentercompany: "Please enter company / study",
    Registernow: "Register now",
    agree: "I have read and agree",
    privacy: "《FSOM privacy clause》",
  },
  // 登录
  Signin: {
    Signin: "Login and registration",
    account: "account",
    mailbox: "Please enter email",
    password: "password",
    VerificationCode: "Verification Code",
    login: "Sign in",
    Forgetpassword: "Forget password",
    nomember: "You are not a member yet",
    Registeredmember: "Register as a member now",
    Registernow: "Register now",
    title: "Focus on chip field",
    noaccount: "No account yet？",
    input: "Please enter email",
    tipsOut: "Log out or not?",
    outSuc: "Exit successful",
  },
  // 订单
  order: {
    tip: "Delete prompt",
    confirmTip: "Are you sure you want to delete?",
    cancelOk: "Delete successful",
    Paymenttime: "Payment time",
    Paid: "Paid",
    Putitaway: "Put it away",
    details: "details",
    Cancelpayment: "Are you sure to cancel the order？",
    title: "Do you confirm immediate payment？",
    Productnumber: "Product number",
    Productdescription: "Product description",
    UnitPrice: "Unit Price",
    Purchasequantity: "Purchase quantity",
    current: "Current order status",
    Totalamount: "Total order amount",
    contact: "customer service",
    shinformation: "Consignee information",
    wlinformation: "Logistics information",
    wlcompany: "logistics company",
    wlorderno: "Logistics No",
    ddinformation: "Order information",
    Creationtime: "Creation time",
    bystages: "hire purchase",
    information: "Commodity information",
    Price: "Price",
    integral: "integral",
    state: "Order status",
    edit: "edit",
    number: "Order No",
    num: "number",
    exchange: "Exchange application in progress",
    returngoods: "Return / refund application in progress",
    hcomplete: "Exchange completed",
    tcomplete: "Return / refund completed",
    Rejected: "After sales rejected",
    Closed: "Closed",
    payment: "Immediate payment",
    upcontract: "Upload contract",
    Dcontract: "Download contract",
    Gcontract: "Company",
    Ycontract: "User",
    Aftersales: "After sales",
    Billing: "Apply for invoicing",
    Confirmreceipt: "Confirm receipt",
    Corder: "cancellation",
    deletes: "Delete order",
    ApplyBilling: "invoicing",
    BillingType: "Billing type",
    domesticBilling: "Domestic billing",
    abroadBilling: "Foreign billing",
    periodsNum: "Number of periods",
    corporatename: "corporate name",
    taxpayer: "Taxpayer identification number",
    address: "Company address",
    tel: "Company phone",
    OpeningName: "Name of opening bank",
    OpeningAccount: "Bank account",
    Applynow: "Apply now",
    up: "Drag files here, or",
    clickUp: "Click upload",
    upTxt: "Only word files or PDF files can be uploaded, and no more than 5m",
    Applysales: "Apply for after sales",
    AftersalesType: "After sales type",
    Pleaseselect: "Please select",
    input: "Please enter",
    AftersalesReason: "After sales reasons",
    Cancel: "Cancel",
    determine: "determine",
    d: "The first",
    q: "stage",
    typeList: ["Finished goods order", "Sample order", "Custom order"],
    rules: {
      resource: [
        {
          required: true,
          message: "Please select billing type",
          trigger: "change",
        },
      ],
      // type: [{
      // 	type: 'array',
      // 	required: true,
      // 	message: '请至少选择一个活动性质',
      // 	trigger: 'change'
      // }],
      name: [
        {
          message: "Please enter company name",
          required: true,
        },
      ],
      num: [
        {
          message: "Please enter taxpayer identification number",
          // required: true,
        },
      ],
      city: [
        {
          message: "Please enter company address",
          required: true,
        },
      ],
      tel: [
        {
          message: "Please enter the company phone number",
          required: true,
        },
      ],
      kfhmc: [
        {
          message: "Please enter the name of the opening bank",
          required: true,
        },
      ],
      kfhzh: [
        {
          message: "Please enter the account of the Bank of deposit",
          required: true,
        },
      ],
    },
    options: [
      {
        value: "1",
        label: "return goods",
      },
      {
        value: "2",
        label: "exchange goods",
      },
      {
        value: "3",
        label: "refund",
      },
    ],
    stateList: [
      [
        {
          text: "state：",
          state: -1,
        },
        {
          text: "whole",
          state: "",
        },
        {
          text: "To be paid",
          state: 1,
        },
        {
          text: "To be delivered",
          state: 2,
        },
        {
          text: "To be received",
          state: 3,
        },
        {
          text: "Completed",
          state: 4,
        },
        {
          text: "Order close",
          state: 5,
        },
        {
          text: "After sales",
          state: 6,
        },
      ],
      [
        {
          text: "state：",
          state: -1,
        },
        {
          text: "whole",
          state: "",
        },
        {
          text: "To be reviewed",
          state: 0,
        },
        {
          text: "To be delivered",
          state: 1,
        },
        {
          text: "To be received",
          state: 2,
        },
        {
          text: "Completed",
          state: 3,
        },
        {
          text: "Reject application",
          state: 4,
        },
        {
          text: "Cancelled",
          state: 5,
        },
      ],
      [
        //0待审核 ，1待用户上传合同 2合同待审核 3待设置款项 4待付款 5待发货 6合同审核驳回 7订单审核驳回 8已完成 9已取消
        {
          text: "state：",
          state: -1,
        },
        {
          text: "whole",
          state: "",
        },
        {
          text: "To be reviewed",
          state: 0,
        },
        {
          text: "Contract to be uploaded",
          state: 1,
        },
        {
          text: "Contract to be reviewed",
          state: 2,
        },
        {
          text: "Amount to be set",
          state: 3,
        },
        {
          text: "To be paid",
          state: 4,
        },
        {
          text: "To be delivered / received",
          state: 5,
        },
        {
          text: "Rejection of contract",
          state: 6,
        },
        {
          text: "Order rejection",
          state: 7,
        },
        {
          text: "Completed",
          state: 8,
        },
        {
          text: "Cancelled",
          state: 9,
        },
        {
          text: "After sales",
          state: 10,
        },
      ],
    ],
  },
  // 状态
  state: {
    Shipped: "Shipped",
    payment: "To be paid",
    delivergoods: "To be delivered",
    Distribution: "Distribution in progress",
    Completed: "Completed",
    close: "Order close",
    toexamine: "To be reviewed",
    Receipt: "To be received",
    Receivedgoods: "Received goods",
    Rejected: "Rejected",
    Cancelled: "Cancelled",
    upload: "Contract to be uploaded",
    htToexamine: "Contract to be reviewed",
    setup: "Amount to be set",
    htreject: "Rejection of contract review",
    ddreject: "Order approval rejection",
    Submit: "To be submitted",
    Underreview: "Under review",
    Passed: "Passed",
  },
  // 远程技术
  technology: {
    english: "english",
    chinese: "chinese",
    video: "Videoconferencing",
    tel: "Telephone",
    communicate: "Offline communication",
    no: "Not accepted",
    Accepted: "Accepted",
    Completed: "Completed",
    Cancelled: "Cancelled",
    cancel: "cancel",
    edit: "edit",
    launch: "Initiate remote technical support",
    noData: "No data yet",
    longrange: "Remote technical support",
    close: "close",
    input: "Please enter content",
    choice: "Please select",
    Submit: "Submit",
    thead: [
      {
        width: "col-3",
        align: "center",
        title: "problem",
      },
      {
        width: "col-3",
        align: "center",
        title: "time",
      },
      {
        width: "col-3",
        align: "center",
        title: "Ways of communication",
      },
      {
        width: "col-2",
        align: "center",
        title: "language",
      },
      {
        width: "col-3",
        align: "center",
        title: "remarks",
      },
      {
        width: "col-2",
        align: "center",
        title: "state",
      },
      {
        width: "col-4",
        align: "center",
        title: "edit",
      },
    ],
    dataTitleGroup: {
      communication: "mode",
      remark1: "Your question",
      communicationRemark: "remarks",
      scheduled: "time",
      remark: "Other remarks",
      language: "language",
    },
  },
  // 我的项目
  project: {
    submitted: "To be submitted",
    underReview: "Under review",
    Passed: "Passed",
    Rejected: "Rejected",
    cancel: "cancel",
    edit: "edit",
    Submit: "Submit",
    add: "Add my project",
    newlyadded: "newly added",
    Myproject: "My project",
    close: "close",
    Pleaseenter: "Please enter content",
    thead: [
      {
        width: "col-4",
        align: "center",
        title: "entry name",
      },
      {
        width: "col-4",
        align: "center",
        title: "contact number",
      },
      {
        width: "col-4",
        align: "center",
        title: "Project description",
      },
      {
        width: "col-4",
        align: "center",
        title: "Project status",
      },
      {
        width: "col-4",
        align: "center",
        title: "edit",
      },
    ],
    dataTitleGroup: {
      projectName: "entry name",
      phone: "contact number",
      projectDescribe: "description",
    },
    dataGroup: {
      projectName: "entry name",
      phone: "contact number",
      projectDescribe: "description",
    },
    cancelErr: "Cancel failed",
    hasCancel: "Project submission cancelled",
  },
  // 商品详情
  shopDet: {
    Purchasequantity: "Purchase quantity",
    see: "View RMB price",
    application: "Product parameters",
    purchase: "Buy now",
    shoppingCart: "add to cart",
    sample: "Sample application",
    consume: "consume",
    integral: "integral",
    Collection: "Collect this item",
    deletes: "Delete",
    cancel: "Cancelcollection",
    Documentname: "Document name",
    description: "Document description",
    size: "file size",
    time: "time",
    download: "download",
    consignee: "consignee",
    tel: "contact number",
    address: "Receiving address",
    apply: "Apply now",
    rules: {
      consignee: [
        {
          required: true,
          message: "Please enter the consignee",
          trigger: "blur",
        },
      ],
      tel: [
        {
          required: true,
          message: "Please enter the contact number",
          trigger: "blur",
        },
      ],
      city: [
        {
          required: true,
          message: "Please enter the receiving address",
          trigger: "blur",
        },
      ],
      region: [
        {
          required: true,
          message: "Please select the activity area",
          trigger: "change",
        },
      ],
      resource: [
        {
          required: true,
          message: "Please select active resources",
          trigger: "change",
        },
      ],
    },
  },
  //首页
  homePage: {
    product: "All product categories",
    hi: "Welcome to FSOM",
    sign: "Sign in",
    register: "register",
    newsflash: "FSOM Express",
    more: "more",
    footprint: "footprint",
    member: "member",
    account: "account",
    news: "news",
    order: "order",
    long_range: "long-range",
    wallet: "wallet",
    project: "project",
    Collection: "Collection",
    data: "data",
    recommend: "recommend",
    Hot: "Hot recommendations",
    whole: "whole",
    Passive: "Passive components",
    Active: "Active device",
    magnifier: "magnifier",
    chip: "External chip",
    Hots: "Hot",
    Newproducts: "New",
    honor: "honor",
    course: "course",
    partner: "partner",
    briefintroduction: "brief introduction",
    MembershipCenter: "member",
    PersonalCenter: "Message center",
    kfTime: "Customer service online (Beijing time)",
    Telephone: "contact number",
    PreSsale: "Pre sales contact email",
    AfterSales: "After sales contact email",
    all: "ALL",
    hot: "HOT RECOMMENDATIONS",
    more: "more",
    solution: "SOLUTION",
    aboutUS: "ABOUT US",
    friend: "Friendly Links",
  },
  // 搜索
  search: {
    arr: ["whole", "product", "file", "information"],
    home: "home page",
    search: "search",
    product: "product",
    file: "file",
    information: "information",
    common: "common",
    result: "Results",
    model: "model",
    stock: "stock",
    Price: "Price",
    details: "details",
    member: "Member Download",
    ordinary: "Normal Download",
    Views: "Views",
    Download: "Download volume",
    time: "Upload time",
    thead: [
      {
        title: "Commodity information",
        width: "col-8",
        align: "center",
      },
      {
        title: "Price",
        width: "col-4",
        align: "center",
      },
      {
        title: "operation",
        width: "col-8",
        align: "center",
      },
    ],
  },
  // 会员中心
  vip: {
    billingRecord: "Billing record",
    Cashier: "Cashier",
    system: "system",
    order: "order",
    Company: "W",
    Account: "Account information",
    vip: "Membership level",
    Receiving: "Receiving information",
    personal: "personal data",
    Changezf: "Change payment password",
    Change: "Change Password",
    out: "Sign out",
    finished: "Finished goods",
    sample: "Sample order",
    customized: "Custom order",
    whole: "View all",
    shop: "Commodity information",
    Price: "Price",
    type: "Order status",
    edit: "edit",
    number: "Order No",
    num: "number",
    payment: "Immediate payment",
    cancel: "cancellation",
    news: "My news",
    available: "No data available",
    balance: "Account balance",
    balances: "balance",
    integral: "integral",
    Collection: "My collection",
    footprint: "My Tracks",
    technology: "Remote technical support",
    project: "My project",
    launch: "Click to initiate",
    no_project: "No project",
  },
  // 技术分享
  tgshare: {
    title: "Value lies in sharing",
    txt: "Dedicated to providing engineers with rich application design, circuit diagram, application scheme, industry software and other information",
    selection: "Selected",
    empty: "Clear filter",
    search: "search result",
    strip: "strip",
    classification: "Document classification",
    jurisdiction: "Download permission",
    member: "Member Download",
    ordinary: "Normal download",
    Views: "Views",
    Download: "Download volume",
    Upload: "Upload time",
    tab: ["whole", "member", "Free Admission"],
    inp: "Please enter the data name",
  },
  // 售后服务
  service: {
    txt: "Adhering to the customer first business philosophy, with strict management and control of service processes, in strict accordance with service standards and dedication to provide every customer with the best solution. We have a highly qualified customer service consultant team to provide you with 7*24 hours online support, to maximize the allocation of resources, to ensure that every detail is considerate. We have launched an all-round demand receiving mode, and the professional technical team provides online services 24 hours a day. Customers can communicate with FSOM service engineers through various service response channels such as telephone consultation, email, fax, QQ, etc. without waiting in line, they can quickly seek solutions.",
    apply: "Apply for after sales",
    my: "My after sales",
  },
  //页面导航条
  nav: {
    home: "Home Page",
    menberCenter: "Membership Center",
    proCenter: "Product Center",
    service: "Customized Services",
    share: "Technology Sharing",
    afterSale: "Help Center",
    aboutUS: "About Us",
  },
  //定制订单申请
  customizedApply: {
    productName: "Product name",
    indexRequirement: "Index requirements",
    sizeRequirement: "Dimensional requirements",
    demandQuantity: "Demand quantity",
    deliveryCycle: "Lead time",
    qualityGrade: "Quality level",
    weight: "weight(g)",
    installationMode: "Installation method",
    useEnvironment: "Use environment",
    otherProcessRequirements: "Other process requirements",
    detailedDescription: "Detailed description",
    sendAddress: "Receiving address",
    contractStyle: "contact information",
    receivingUser: "contacts",
    annexFile: "Upload attachment",
    confirmApply: "Confirm upload",
    remove: "remove",
    confirmSubmit: "Are you sure to submit the data？",
    title: "Tips",
    alertText: "Application succeeded, please wait for platform review",
    submitting: "Submitting data",
    submiterr: "Failure to submit ",
    uploadFile: "Uploading file",
    uploadFileError: "File upload failed",
  },

  //我的余额
  accountBalance: {
    apply: "Application for cash withdrawal",
    Withdrawalrefund: "Withdrawal refund",
    Accountrecharge: "Account recharge",
    Paymentorder: "Payment order",
    Orderrefund: "Order refund",
    Sampleapplication: "Sample application",
    deduction: "Deduction of purchased goods",
    Closeorder: "Close order, return points",
    Completeorder: "Bonus points for completing the order",
    my: "my",
    wallet: "wallet",
    integral: "integral",
    Recharge: "Recharge",
    Withdrawal: "Withdrawal",
    bill: "My bill",
    no: "No data available",
    balance: "Personal currency account",
    dollar: "USD account",
    Alipay: "Alipay",
    record: "Withdrawal record",
    stay: "To be reviewed",
    adopt: "Approved",
    reject: "Rejection of audit",
    integralRecord: "Integral record",
    complete: "Get points for order completion",
    typeList: ["My wallet", "My points"],
    payHead: [
      {
        width: "col-4",
        align: "center",
        title: "Creation time",
      },
      {
        width: "col-4",
        align: "center",
        title: "amount of money",
      },
      {
        width: "col-4",
        align: "center",
        title: "Transaction type",
      },
      {
        width: "col-5",
        align: "center",
        title: "order number",
      },
      {
        width: "col-3",
        align: "center",
        title: "transaction mode",
      },
    ],
    cashHead: [
      {
        width: "col-5",
        align: "center",
        title: "Start time",
      },
      {
        width: "col-5",
        align: "center",
        title: "Withdrawal amount",
      },
      {
        width: "col-5",
        align: "center",
        title: "Type of withdrawal",
      },
      {
        width: "col-5",
        align: "center",
        title: "Withdrawal progress",
      },
    ],
    integralHead: [
      {
        width: "col-5",
        align: "center",
        title: "time",
      },
      {
        width: "col-4",
        align: "center",
        title: "Transaction type",
      },
      {
        width: "col-6",
        align: "center",
        title: "order number",
      },
      {
        width: "col-5",
        align: "center",
        title: "integral",
      },
    ],
  },
  messageCenter: {
    communicate: "communicate",
    systemNotice: "System notification",
    orderMessage: "Order message",
    noData: "No data available",
    messageClass: {
      confirmMsg: "confirmation message",
      payMsg: "Payment message",
      jumpMsg: "Jump message",
      toPay: "To pay",
      clickConfirm: "Click to confirm",
      confirm: "Confirmed",
      clickJump: "Click to jump",
      confirmSuccess: "Confirm success",
      confirmError: "Confirmation failed",
    },
    loadMsgErr: "Chat component failed to load",
    confirmSuccess: "Confirm success",
    confirmError: "Confirmation failed",
    confirmTitle:
      "This operation will confirm the message content. Do you want to continue?",
    loadErr: "Load failed",
    messageWindow: {
      closeWin: "close window",
      backService: "FSOM after sales service",
      title:
        "Warm tip: customer service hours: 9:00-18:00 Monday to Friday (Beijing time)",
      clickLoadMore: "Click to load more",
      loading: "Loading... ",
      noMore: "No more",
      placeholder: "Please input text content",
      send: "send out",
      loadError: "Failed to get message",
      sendError: "Failed to send message",
    },
  },
  product: {
    startBuy: "Starting from ",
    buy: "Purchase quantity over ",
    unitPrice: "Unit Price",
    goodsLoop: "Delivery period",
    price: "Price",
  },
  privacy: privacyEN,
  ...enLocale,
};

export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js